import { EventEmitter } from "events";
import axios from "axios";

// Crear la instancia
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // habilita cookies (ej: HttpOnly JWT)
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Controlador de eventos globales
export const apiEvents = new EventEmitter();

// ======= SISTEMA DE DETECCIÓN DE SOLICITUDES REPETIDAS =======
const requestCounter = new Map(); // clave: firma del request, valor: contador
const MAX_REQUEST_RETRIES = 3;

// Genera una clave única basada en URL + método + data
function getRequestKey(config) {
  const dataString =
    typeof config.data === "object" ? JSON.stringify(config.data) : config.data;
  return `${config.method}:${config.url}:${dataString}`;
}

// ======= INTEGRAR SOCKET_ID GLOBAL SIN REPETIR CÓDIGO =======
export function attachEcho(echoInstance) {
  window.__ECHO__ = echoInstance;
  console.log("🔌 Echo registrado en Axios");
}

// Interceptor REQUEST
api.interceptors.request.use(
  (config) => {
    // 👉 Agregar automáticamente X-Socket-Id si Echo está conectado
    if (window.__ECHO__) {
      const socketId = window.__ECHO__.socketId();
      if (socketId) {
        config.headers["X-Socket-Id"] = socketId;
        // console.log("🔗 Enviando X-Socket-Id:", socketId);
      }
    }

    //  Control de requests duplicados
    const key = getRequestKey(config);
    const count = requestCounter.get(key) || 0;

    if (count >= MAX_REQUEST_RETRIES) {
      console.error(
        "⚠️ Múltiples solicitudes detectadas. Activando bloqueo de bucle."
      );
      return Promise.reject(
        new Error(
          "Múltiples solicitudes detectadas. Activando bloqueo de bucle."
        )
      );
    }

    requestCounter.set(key, count + 1);

    // Limpiar después de 10 segundos para evitar crecimiento del mapa
    setTimeout(() => requestCounter.delete(key), 10000);

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor RESPONSE
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("No autorizado - emitiendo evento de logout");
      apiEvents.emit("unauthorized");
    }
    return Promise.reject(error);
  }
);

export default api;
